module.exports = __webpack_public_path__ + "images/izz_small1df916f7bf61b75d0635081858eb939d.png";